export { default } from './OperatorDashboard';
